export default __webpack_public_path__ + "static/media/3392-linsanity.cb9bf87e.pdf";